import { AuthRepository } from '../Repositories/AuthRepository';
import { User } from '../../Model/User';
import { stripSuffix } from '../../../../Utils/usernameSuffix';

function normalizeUser(user: User): User {
  return {
    ...user,
    username: stripSuffix(user.username),
    createdAt: user.createdAt ?? user.created_at ?? '',
  };
}

export class MeUseCase {
  constructor(private repo: AuthRepository) {}
  async execute(): Promise<User> {
    const user = await this.repo.me();
    return normalizeUser(user);
  }
}
